import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const EmailJobContext = createContext();

export const useEmailJobs = () => {
    const context = useContext(EmailJobContext);
    if (!context) {
        throw new Error('useEmailJobs must be used within EmailJobProvider');
    }
    return context;
};

export const EmailJobProvider = ({ children }) => {
    const [activeJobs, setActiveJobs] = useState(() => {
        // Load from localStorage on mount
        try {
            const stored = localStorage.getItem('activeEmailJobs');
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            return [];
        }
    });

    // Save to localStorage whenever activeJobs changes
    useEffect(() => {
        try {
            localStorage.setItem('activeEmailJobs', JSON.stringify(activeJobs));
        } catch (e) {
            console.error('Failed to save active jobs to localStorage:', e);
        }
    }, [activeJobs]);

    const addJob = useCallback((jobId, jobInfo) => {
        setActiveJobs(prev => {
            const exists = prev.find(j => j.jobId === jobId);
            if (exists) return prev;
            return [...prev, { jobId, ...jobInfo, addedAt: new Date().toISOString() }];
        });
    }, []);

    const removeJob = useCallback(jobId => {
        setActiveJobs(prev => prev.filter(j => j.jobId !== jobId));
    }, []);

    const updateJobInfo = useCallback((jobId, updates) => {
        setActiveJobs(prev => prev.map(j => (j.jobId === jobId ? { ...j, ...updates } : j)));
    }, []);

    return (
        <EmailJobContext.Provider
            value={{
                activeJobs,
                addJob,
                removeJob,
                updateJobInfo,
            }}
        >
            {children}
        </EmailJobContext.Provider>
    );
};
